export const baseURL = window.__ENV__?.REACT_APP_baseURL || process.env.REACT_APP_baseURL;
export const assetsURL = window.__ENV__?.REACT_APP_assetsURL || process.env.REACT_APP_assetsURL;
// export const baseURL ='http://localhost:8080';